import { useEffect, useRef } from 'react';

/**
 * Poll `fn` every `ms` milliseconds, but only while the page is visible.
 * Fires immediately on mount and again the moment the tab/screen becomes
 * visible, so data is never stale when the user returns.
 *
 * Backgrounded tabs and locked phone screens skip every tick: on mobile the
 * constant radio wake-ups from blind setInterval polling are a real battery
 * and data cost (and pointless server load).
 */
export default function useVisiblePoll(fn, ms, deps = []) {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  useEffect(() => {
    const run = () => { if (!document.hidden) fnRef.current(); };
    run();
    const id = setInterval(run, ms);
    document.addEventListener('visibilitychange', run);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', run);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ms, ...deps]);
}
